import React, { useState, useEffect } from 'react';

import confirmAlert from 'components/new_ui/Alerts/confirm';
import Table from 'components/new_ui/Table';
import { useContext } from 'components/Managers/Teams/Context';
import EditModal from 'components/Managers/Teams/Views/Edit/Index';
import columns from './columns';

export default function Index() {
  const { state, dispatch, actions } = useContext();
  const [showEditModal, setShowEditModal] = useState(false);

  useEffect(() => {
    actions.load(dispatch);
  }, []);

  const rowActions = [
    {
      title: 'Edit',
      type: 'CUSTOM',
      iconClass: 'edit-icon',
      onClick: (row) => {
        actions.select(dispatch, row);
        setShowEditModal(true);
      },
    },
    {
      title: 'Delete',
      type: 'CUSTOM',
      iconClass: 'trash-icon',
      onClick: (row) => {
        confirmAlert({
          title: 'Delete',
          text: 'Are you sure you want to delete?',
          confirmButtonText: 'Delete',
        }, () => {
          actions.destroy(dispatch, row);
        });
      },
      showCondition: (row) => !row.attributes.is_default,
    },
  ];

  return (
    <section className="pt-2">
      <Table
        title=" "
        columns={columns}
        data={state.teams || []}
        loading={state.teams === null}
        selectableRows={false}
        rowActions={rowActions}
      />

      {state.selectedTeam && (
        <EditModal
          show={showEditModal}
          onCloseClick={() => setShowEditModal(false)}
        />
      )}
    </section>
  );
}
